import {
  ADVERTISING_FETCH,
  ADVERTISING_ADD,
  ADVERTISING_EDIT,
  ADVERTISING_REMOVE,
  ADVERTISING_ERROR
} from "../store/types";

const INITIAL_STATE = {
  date: [],
  loading: false,
  error: {
    flag: false,
    msg: null
  }
};

export const advertisingreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADVERTISING_FETCH:
      return {
        ...state,
        date: action.payload,
        loading: false
      };
    case ADVERTISING_ADD:
      return {
        ...state,
        date: [...state.date, action.payload],
        loading: false
      };
    case ADVERTISING_EDIT:
      const updatedData = state.date.map(item =>
        item.ref === action.payload.ref ? action.payload : item
      );
      return {
        ...state,
        date: updatedData,
        loading: false
      };
    case ADVERTISING_REMOVE:
      const filteredData = state.date.filter(item => item.ref !== action.payload.ref);
      return {
        ...state,
        date: filteredData,
        loading: false
      };
    case ADVERTISING_ERROR:
      return {
        ...state,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    default:
      return state;
  }
};
